import Logo from "../components/Logo";
import Content from "../components/Content";
import Footer from "../components/Footer";
import terms from "../data/termsData";

const ConditionsAndTerms = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Logo src="/images/bunat.png" alt="Bunat Logo" className="w-32 sm:w-40 md:w-48" />
      <div
        data-aos="fade-up"
        className="grid items-end px-4 sm:px-8 md:px-20 lg:px-36  "
      >
        <h1 className="text-2xl font-bold text-lightGreen mb-6 ">الشروط والأحكام</h1>
        <p className="text-blackText leading-relaxed max-w-full mb-2 sm:max-w-2xl text-right tracking-wide text-base sm:text-base ">
          مرحباً بك في تطبيق بُناة التطوعي. باستخدامك لهذا التطبيق، فإنك توافق على الالتزام بهذه الشروط والأحكام كاملة، لذا يرجى قراءتها بعناية.
        </p>
        <Content sections={terms} />
      </div>
      <Footer />
    </div>
  );
};

export default ConditionsAndTerms;
